export default __webpack_public_path__ + "static/media/hango-mobile-3.9448b954.png";